import { useContext } from 'react'
import styled from 'styled-components'
import { PredictionOfPassedContainerContext } from '@app.feature/exam/gsat2024-2/context/PredictionOfPassedContainerContext'
import { compareCorrectRates } from '@app.feature/exam/gsat2024-2/modules/testResult.module'
import CircleInfoItemDesktop, {
  CircleInfoItemDesktopProps,
} from './CircleInfoItem.desktop'

const CircleInfoArticleDesktop = () => {
  const { examGradingResultData, isLoading } = useContext(
    PredictionOfPassedContainerContext,
  )

  if (isLoading) return null

  const compareOverrallGradingRate = compareCorrectRates(
    examGradingResultData?.viewerResult.correctRate || 0,
    examGradingResultData?.overallExamGradingResult.correctRate || 0,
  )

  const compareTop30PercentGradingRate = compareCorrectRates(
    examGradingResultData?.viewerResult.correctRate || 0,
    examGradingResultData?.top30percentOfOverallExamGradingResult.correctRate ||
      0,
  )

  const compareSameInfoGradingRate = compareCorrectRates(
    examGradingResultData?.viewerResult.correctRate || 0,
    examGradingResultData?.subsidiaryJobExamGradingResultOfSameInfo
      .correctRate || 0,
  )

  const CICLE_INFO_DATA: CircleInfoItemDesktopProps[] = [
    {
      infoTitle: '전체 응시생 \n평균 맞은 문항 수보다 약',
      userPercent: compareOverrallGradingRate,
      averageText: '전체 응시생 평균 맞은 문항수',
      averagePercent:
        examGradingResultData?.overallExamGradingResult.correctCount || 0,
    },
    {
      infoTitle: '상위 30% 응시생 \n평균 맞은 문항 수보다 약',
      userPercent: compareTop30PercentGradingRate,
      averageText: '상위 30% 응시생 평균 맞은 문항수',
      averagePercent:
        examGradingResultData?.top30percentOfOverallExamGradingResult
          .correctCount || 0,
    },
    {
      infoTitle: '동일 계열사/직무 응시생\n평균 맞은 문항 수보다 약',
      userPercent: compareSameInfoGradingRate,
      averageText: '동일 계열사/직무 응시생 평균 맞은 문항수',
      averagePercent:
        examGradingResultData?.subsidiaryJobExamGradingResultOfSameInfo
          .correctCount || 0,
    },
  ]

  return (
    <StyledWrapper>
      {CICLE_INFO_DATA.map((data, index) => {
        return (
          <CircleInfoItemDesktop
            key={`circle-info-item-id-${index}`}
            {...data}
          />
        )
      })}
    </StyledWrapper>
  )
}

export default CircleInfoArticleDesktop

const StyledWrapper = styled.div`
  width: 100%;
  padding: 48px 56px;
  border-radius: 10px;
  background-color: #ffffff;
  display: flex;
  justify-content: space-between;
`
